import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const locale = require("react-redux-i18n").I18n;

const ContestHeader = () => {
  const [isIdex, setIndex] = React.useState(0);
  const pathName = window.location.pathname;
  const MenuItem = styled.div`
    padding: 0.8rem 1rem;
    color: ${(props) => props.color};
    border-bottom: ${(props) => props.borderBottom};
    white-space: pre;
    font-weight: ${(props) => props.fontWeight};
  `;

  const menu = [
    {
      id: 0,
      link: `/${localStorage.getItem("locale")}/wallet/contest/new-events`,
      text: locale.t("cardContest.tab.new_events"),
      name: "new-events",
    },
    {
      id: 1,
      link: `/${localStorage.getItem("locale")}/wallet/contest/previous-events`,
      text: locale.t("cardContest.tab.previous_events"),
      name: "previous-events",
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-end" style={{ padding: "40px 40px 0px 40px" }}>
        <p className="text-header-account-wallet text-left w-100">Contest</p>
      </div>
      <div
        className="sub-menu-page-user mt-4"
        style={{ borderBottom: "1px solid #D9D9D9" }}
      >
        <div
          className="d-flex overflow-auto scroll-menu-hide"
          style={{ padding: "0px 40px 0px 40px" }}
        >
          {menu.map((e, i) => (
            <Link to={e.link} key={i}>
              <MenuItem
                onClick={() => setIndex(i)}
                color={
                  e.link === pathName
                    ? "#000"
                    : pathName.includes(e.name)
                    ? "#000"
                    : "#8D8D8D"
                }
                borderBottom={
                  e.link === pathName
                    ? "4px solid #1CB894"
                    : pathName.includes(e.name)
                    ? "4px solid #1CB894"
                    : "2px solid #ff000000"
                }
                fontWeight={
                  e.link === pathName
                    ? "600"
                    : pathName.includes(e.name)
                    ? "600"
                    : "unset"
                }
              >
                {e.text}
              </MenuItem>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContestHeader;
